<template>
	<div>
		<!-- 轮播图 -->
		<el-carousel height="398px">
		  <el-carousel-item v-for="(item, index) in bannerList" :key="index">
		    <img style="width: 100%;height: 100%;" :src="item"/>
		  </el-carousel-item>
		</el-carousel>
		
		<!-- 关于我们 -->
		<div class="container">
			<div class="content">
				<div style="font-size: 28px;text-align: center;margin: 50px 0 60px;">关于我们</div>
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<img src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808242.jpg" style="width: 604px;height: 339px;"/>
					<div style="width: 431px;color: #555;line-height: 1.75;font-size: 14px;margin-right: 80px;">上海中雅国际物流有限公司隶属于香港中雅国际，成立于2012年6月，中国总部位于上海虹口海泰国际大厦，公司注册资金500万人民币，公司拥有交通部无船承运人（NVOCC）、代理报关、代理报检等一整套国际运输业务经营资质。业务涵盖全球海运、空运进出口货物和过境货物的国际运输代理业务，包括揽货、仓储、中转、集装箱拼装拆箱、结算运杂费、报关、报验、保险相关的运输服务及咨询业务。公司一直秉承专业、诚信、进取的服务核心，旨在通过自己不懈的努力，为企业连接一切商机，帮助客户在时代和环境中保持优势，与客户风雨同行、共同成长。</div>
				</div>
			</div>
		</div>
		
		<!-- 成长历程 -->
		<div class="container" style="flex-wrap: wrap;">
			<div style="text-align: center;font-size: 28px;line-height: 60px;margin: 80px 0 50px;width: 100%;">用数据见证中雅的点滴成长</div>
			<div class="container" style="background-color: rgb(238, 238, 238);">
				<div class="content" style="margin-bottom: 120px;">
					<div style="display: flex;justify-content: space-between;margin-top: 90px;">
						<div v-for="item in numberData" style="display: flex;justify-content: center;flex-wrap: wrap;text-align: center;">
							<i class="mw-iconfont w-button-icon" style="width: 100%;font-size: 40px;color: #333;">{{item.icon}}</i>
							<div style="width: 100%;font-size: 36px;color: #333;margin-top: 30px;">{{item.number}}</div>
							<div style="color: #666;font-size: 16px;">{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 高效服务 -->
		<div class="container">
			<div class="content" style="padding-bottom: 80px;">
				<div style="font-size: 28px;text-align: center;margin: 50px 0 60px;">高效服务</div>
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<img src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808243.png" style="width: 604px;height: 339px;"/>
					<div style="width: 518px;">
						<div v-for="(item, index) in aboutData" style="display: flex;align-items: center;" :style="index < aboutData.length - 1 ? {marginBottom: '70px'} : {}">
							<i class="mw-iconfont w-button-icon" style="font-size: 40px;">{{item.icon}}</i>
							<div style="color: #333;margin-left: 40px;">
								<div style="font-size: 16px;">{{item.name}}</div>
								<div style="font-size: 14px;margin-top: 20px;">{{item.content}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 联系我们 -->
		<div class="container" style="background-color: rgb(238, 238, 238);">
			<div class="content" style="display: flex;justify-content: space-between;padding: 60px 0;align-items: center;">
				<div style="width: 576px;">
					<div style="font-size:28px;line-height: 1.5;">联系我们</div>
					<div style="width: 341px;height: 1.5px;background-color: rgba(221,221,221,1);margin: 35px 0 40px;"></div>
					<div style="font-size: 14px;color: #666;line-height: 20px;">
						<div style="display: flex;margin-bottom: 25px;">
							<img style="width: 20px;height: 20px;margin-right: 10px;" src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1052318922.png"/>
							<div style="width: 46px;">地址：</div>
							<div style="width: calc(100% - 76px);">浙江省义乌市廿三里街道华盛路151号5号楼一楼</div>
						</div>
						<div style="display: flex;margin-bottom: 25px;">
							<img style="width: 18px;height: 18px;margin-right: 10px;" src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1052318921.png"/>
							<div style="width: 46px;">电话：</div>
							<div>+8613566791116（AGUS：08815392066）</div>
						</div>
						<div style="display: flex;margin-bottom: 25px;">
							<img style="width: 18px;height: 18px;margin-right: 10px;" src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1052318920.png"/>
							<div style="width: 46px;">邮箱：</div>
							<div>indonesia_china@163.com</div>
						</div>
						<div style="display: flex;margin-bottom: 25px;">
							<img style="width: 20px;height: 20px;margin-right: 10px;" src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1052318922.png"/>
							<div style="width: 66px;">Alamat：</div>
							<div style="width: calc(100% - 96px);">
								Ruko Mangga Dua Square Blok. D No. 21 Jl. Gunung Sahari Raya No. 1 , Ancol , Pademangan (Rt. 11/Rw. 6 Kota Tua) , Jakarta Utara PADEMANGAN, DKI JAKARTA , ID , 14420
							</div>
						</div>
					</div>
				</div>
				<div style="width: 550px;">
					<gmap-map v-if="center" id="map" :center="center" :zoom="13" style="height: 360px;">
					  <gmap-marker v-if="mapMarkPosition" :position="mapMarkPosition"/>
					</gmap-map>
					<!-- <el-input placeholder="留言标题" style="margin-bottom: 12px;"/>
					<el-input type="textarea" placeholder="留言内容" style="margin-bottom: 12px;" :autosize="{minRows: 6, maxRows: 6}"/>
					<el-input placeholder="联系电话" style="margin-bottom: 12px;"/>
					<el-input placeholder="验证码" style="margin-bottom: 12px;">
						<img slot="append" src="https://galaxy-logistics.cn/Common/GenerateLeavewordCaptcha?timestamp=0.66100101719974"/>
					</el-input>
					<div style="display: flex;justify-content: right;">
						<el-button type="primary" style="width: 100px;">提交</el-button>
					</div> -->
				</div>
			</div>
		</div>
		
		<!-- 地图定位 -->
		<div class="container">
			<!-- <gmap-map class="content" v-if="center" id="map" :center="center" :zoom="13" style="height: 500px;margin: 15px 0">
			  <gmap-marker v-if="mapMarkPosition" :position="mapMarkPosition"/>
			</gmap-map> -->
		</div>
		
	</div>
</template>

<script>

export default {
	data() {
		return {
			bannerList: ['https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808241.jpg'],
			numberData: [
				{icon: 'ꁐ', name: '客户的选择', number: '1000+'},
				{icon: 'ꄉ', name: '印尼专线', number: '100+'},
				{icon: 'ꀧ', name: '公司成立', number: '7年+'},
				{icon: 'ꁘ', name: '专业团队', number: '30+'},
			],
			aboutData: [
				// {icon: 'ꁙ', name: '高效', content: '超100条航线，覆盖100多个国家，专业订舱能力，货量足，各大航线舱位稳定，天天装柜时效快。'},
				{icon: 'ꁥ', name: '专业', content: '平均6年以上货代经验，服务快速响应，规范化的报价体系，价格优质透明，根据客户需求，定制最优货运方案。'},
				{icon: 'ꄀ', name: '省心', content: '1对1服务团队，提供上门提货、代理商检、报送等一条龙服务，清关和规避风险能力强，货物准时到达。'},
			],
			
			center: {lat: 29.337015877659393, lng: 120.15826051856584},
			mapMarkPosition: {lat: 29.337015877659393, lng: 120.15826051856584},
		}
	},
}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/components/about.vue